module.exports = __webpack_public_path__ + "static/media/telemedicine.04b3ae27.png";